import React, { Suspense } from 'react';
import Header from './components/Header';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useState } from 'react';

import Menu from './components/Menu';
import FullPageLoader from './components/FullPageLoader';
import Footer from './components/Footer';

import { createRoutes } from './routes';
import Modal from './components/Modal/Modal';
import { modalInitialState } from './components/Modal/modalInitialState';

const App = () => {
  const [isModalOpen, setModalOpen] = useState(modalInitialState.isModalOpen);
  const [render, setRender] = useState(null);

  const modalStateSetters = {
    render,
    setRender,
    isModalOpen,
    setModalOpen,
  }

  const routes = createRoutes(modalStateSetters)
  return (
    <Router>
      <Header />
      <Menu />
      <Suspense fallback={<FullPageLoader />}>
        <Routes>
          {routes.map((route, idx) => (
            <Route key={idx} {...route} />
          ))}
        </Routes>
      </Suspense>
      <Modal state={modalStateSetters}/>
      <Footer />
    </Router>
  );
};

export default App;
